import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=b4ff764e"
import script from "./rate.vue?vue&type=script&lang=js"
export * from "./rate.vue?vue&type=script&lang=js"
import style0 from "./rate.vue?vue&type=style&index=0&id=b4ff764e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports